import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiClient from "../../config/AppAdmin";

const initialState = {
  isLoading: false,
  error: null,
  qrOrderList: [],
};

// Fetch all Subscriptions
export const fetchqrOrderList = createAsyncThunk(
  "qrOrder/fetchScriptionList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get("/QrOrder");
      // Check success properly
      if (response.data.success === true) return response.data.data;
      throw new Error("Failed to fetch QrOrders");
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message);
    }
  }
);

// Delete QrOrder
export const deleteQrOrder = createAsyncThunk(
  "qrOrder/deleteQrOrder",
  async (id, { rejectWithValue }) => {
   
    try {
      const response = await ApiClient.delete(`/QrOrder/${id}`);
      if (response.status === 200) return id;
      throw new Error("Failed to delete QrOrder");
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message);
    }
  }
);

const qrOrderSlice = createSlice({
  name: "qrOrder",
  initialState,
  reducers: {
    addqrOrder: (state, action) => {
      // newest on top
      state.qrOrderList.unshift(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchqrOrderList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchqrOrderList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.qrOrderList = action.payload;
      })
      .addCase(fetchqrOrderList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // Delete
      .addCase(deleteQrOrder.fulfilled, (state, action) => {
        state.qrOrderList = state.qrOrderList.filter(
          (d) => d.id !== action.payload
        );
      })
      .addCase(deleteQrOrder.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { addqrOrder } = qrOrderSlice.actions;
export default qrOrderSlice.reducer;
